<template>
	<div>
		<h3>签约商品统计</h3>
		<div class="searchBox">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item label="查看方式">
					<el-select v-model="formInline.statType" placeholder="查看方式">
						<el-option label="按员工查看" value="1"></el-option>
						<el-option label="按渠道查看" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品">
					<el-select v-model="formInline.productId" placeholder="商品">
						<el-option label="全部" value=""></el-option>
						<el-option v-for='(item,index) in shopList' :label="item.name" :value="item.id" :key='index'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="仅查看某渠道" v-if='formInline.statType == 2'>
					<el-select v-model="formInline.subchannel" placeholder="仅查看某渠道" filterable>
						<el-option label="全部" value=""></el-option>
						<el-option v-for='(item,index) in listchannel' :label="item.name" :value="item.id" :key='index'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-else label="仅查看某员工">
					<el-select v-model="formInline.sid" placeholder="仅查看某员工" :disabled="disableBtn" filterable>
						<el-option v-for='(item,index) in peopleList' :label="item.name" :value="item.id" :key='index'></el-option>
					</el-select>
				</el-form-item>
				<br>
					<el-form-item label="时间">
					 <el-date-picker
					  v-model="formInline.time"
					  @change='changeTime'
					  type="daterange"
					  range-separator="至"
					  start-placeholder="开始日期"
					  end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>			
				<el-button class="text2 " type="primary" @click='getData'>查询</el-button>
			</el-form>
		</div>		
		<div class="table">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="user.name" label="销售人员" align='center' v-if='statType == 1'></el-table-column>
				<el-table-column prop="channel" label="销售渠道" align='center' v-else></el-table-column>
				<el-table-column label="销售金额" align='center'>
					<template slot-scope="scope">
						<span class="yellow">{{scope.row.totalSaleAmount/100}} 元</span>
					</template>
				</el-table-column>
				<el-table-column label="销售数量" align='center'>
					<template slot-scope="scope">
						<span>{{scope.row.totalSaleUnit}} 个</span>
					</template>
				</el-table-column>
			</el-table>			
		</div>
		<div class="fenye" v-show="false">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange"
			 :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
			 :total="100">
			</el-pagination>
		</div>		
	</div>
</template>

<script>
	import { statTotal,productList,listchannel,listsub } from '@/axios/api.js'
	import common from '@/assets/common.js'
	export default {
		data() {
			return {
				formInline: {
					statType: '1',
					productId: '',
					subchannel: '',
					time: null,
					sid:'',
					startts:'',
					endts:''
				},
				tableData: [],
				shopList:[],
				listchannel:[],
				peopleList:[],
				statType:'',
				level:JSON.parse(window.localStorage.getItem("token")).data.obj2.level,
				disableBtn:false
			}
		},
		methods:{
			handleSizeChange(val) {//console.log(`每页 ${val} 条`);
				this.eachPage=val;
				this.tableData4=this.tableData.slice(0,this.eachPage);
			},
			handleCurrentChange(val) {//console.log(`当前页: ${val}`);
				this.indexPage=val;
				this.tableData4=this.tableData.slice(this.eachPage * (this.indexPage -1) , this.eachPage * this.indexPage);
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log(val)
			},
			getData(){
				statTotal(this.formInline)
				.then(res => {
					console.log(res);
					this.statType=this.formInline.statType
					this.tableData=res.data.obj
				})
				.catch(err => {
					console.log(err)
				})
			},
			getDataList(){//获取清单列表
				productList({orderType:1})
				.then(res => {
					if(res.data.code == 0){
						this.shopList=res.data.obj
					}else{
						this.$message(res.deta.msg);
					}
				})
				.catch( err => {
					console.log(err)
				})
			},
			getChannel(){
				var data={
					start:0,
					count:1000
				}
				listchannel(data)
				.then( res => {
					if(res.data.code == 0){
						this.listchannel=res.data.obj
					}
				})
				.catch(err => {
					console.log(err)
				})
				//员工
				var data1={
					start:0,
					count:1000
				}
				listsub(data1)
				.then( res => {
					if(res.data.code == 0){
						this.peopleList=res.data.obj;
					}
				})
				.catch(err => {
					console.log(err)
				})				
			},
			changeTime(){
				if(this.formInline.time){
					this.formInline.startts=this.formInline.time[0].getTime()
					this.formInline.endts=this.formInline.time[1].getTime()
				}else{
					this.formInline.startts=''
					this.formInline.endts=''
				}
				
			}
		},
		mounted(){
			this.getData();
			this.getDataList();
			this.getChannel();
			if(this.level == 1){
				this.disableBtn=true
			}
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
	.demo-form-inline .el-range-separator{width: 20px;}
</style>
<style scoped="scoped">
	h3 {
		margin: 20px 0;
		font-weight: normal;
	}

	.searchBox {
		margin-top: 20px;
	}
	.fenye {
		margin-top: 20px;
		overflow: hidden;
	}
	.fenye .pagination {
		float: right;
	}	
</style>



// WEBPACK FOOTER //
// src/views/commodity/statistical.vue